<template>
	<div class="card" v-if="dados.length > 0">
        <div class="card-header">
	    	<div class="d-flex justify-content-between container-fluid">
	            <div class="text-muted fs-19">
	            	<strong>Imagens</strong>
	            </div>
		    </div>
	    </div>
	    <div class="card-body"> 
	        <splide>
			  <splide-slide v-for="dado in dados" :key="dado.id">
			    <img :src="$url+dado.src" width="100%" height="100%">
			  </splide-slide>
			</splide>
	    </div>
	</div>
</template>

<script>
	import '@splidejs/splide/dist/css/themes/splide-default.min.css';
	export default {
		data(){
			return {
				dados: [],
				options: {
				  	rewind: true,
				  	gap   : '1rem',
			  	},
			}
		},
		created(){
			this.getDados()
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/produto-imagens/list/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
	            	this.teste = this.dados[0];
	            	console.log(this.dados)
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			moved(splide, newIndex) {
				console.log('moved', newIndex);
		  	},
		}
	}
</script>